import React, { useMemo } from 'react'
import CheckBoxCustom from '../../../components/atoms/checkbox/CheckBox'
import { formatCommonAmount } from '../../../util/formatAmount'
import { formatCommonDate } from '../../../util/formatDateAndTime'
import PackageSummary from './PackageSummary'
import styles from '../vendorsListPage.module.scss'

const SUMMARY_FIELDS = [
	{ key: 'kazooName', heading: 'Event Name' },
	{
		key: 'startDate',
		heading: 'Start Date',
		format: (v) => formatCommonDate(v),
	},
	{
		key: 'endDate',
		heading: 'End Date',
		format: (v) => formatCommonDate(v),
	},
	{ key: 'guestCount', heading: 'Guest Count' },
	{
		key: 'userBudget',
		heading: 'Budget',
		format: (v) => formatCommonAmount(v),
	},
]

function ProposalSummary({ selectedKazoo, setSelectedKazoo, selectedPackage }) {
	const summary = useMemo(() => {
		if (!selectedKazoo || !Object.keys(selectedKazoo).length) return []
		return SUMMARY_FIELDS.map(({ key, heading, format }) => ({
			heading,
			value: selectedKazoo[key]
				? format
					? format(selectedKazoo[key])
					: selectedKazoo[key]
				: '--',
		}))?.filter((item) => item.value !== '--')
	}, [selectedKazoo])

	return (
		<div className={styles.VendorsListModalBody}>
			<div>
				<div className={styles.summary}>
					<h4>Proposals Summary</h4>
					<div className="">
						<ul>
							{summary.map((item) => (
								<li key={item.heading}>
									<span className={styles.heading}>
										{item.heading}
									</span>
									<span className={styles.value}>
										{item.value}
									</span>
								</li>
							))}
						</ul>
						<PackageSummary selectedPackage={selectedPackage} />
						<div className={styles.requirements}>
							<p className={styles.heading}>Requirements</p>
							<p className={styles.value}>
								{selectedKazoo?.serviceRequirements || '--'}
							</p>
						</div>
					</div>
				</div>
				<CheckBoxCustom
					label="I agree to share my contact information with this vendor and understand they will reach out to discuss my proposal."
					checked={selectedKazoo?.checked || false}
					onChange={(e) =>
						setSelectedKazoo((prev) => ({
							...prev,
							checked: e.target.checked,
						}))
					}
				/>
			</div>
		</div>
	)
}

export default ProposalSummary
